import { render, staticRenderFns } from "./KnSupplierSubcategories.vue?vue&type=template&id=47f56590"
import script from "./KnSupplierSubcategories.js?vue&type=script&lang=js&external"
export * from "./KnSupplierSubcategories.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports